/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.EventRegistrationRpc
 */

export const registerUserToEventSessionRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.EventRegistrationRpc',
  rpcName: 'registerUserToEventSession',
  auth: 'app',
  fingerprint: 'CuXAZN-jCCDVLL39fYG-4zAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deregisterUserFromEventSessionRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.EventRegistrationRpc',
  rpcName: 'deregisterUserFromEventSession',
  auth: 'app',
  fingerprint: 'g9r4nNND3jVbDg8BLbT5mDAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};